import React from 'react'
import { useSession } from 'next-auth/react'
import env from '@beam-australia/react-env'
import useRedirects from '@src/lib/useRedirects'
import AdminLayout from './AdminLayout'

export const withUser: (Page: React.FC) => React.FC = (Page: React.FC) => () => {
  const { data: session, status } = useSession()
  const loading = status === 'loading'

  useRedirects(session, loading)
  if (!session) {
    return (
      <AdminLayout>
        <div className="h-[80vh] w-full flex items-center justify-center">
          <p>
            {
              loading
                ? 'Loading...'
                : (
                  <>
                    {'You must '}
                    <button
                      type="submit"
                      className="px-2 py-1"
                      // redirect the user to the root domain to sign in (it needs to match
                      // NEXTAUTH_URL) and then redirect back to the tenants admin page
                      onClick={() => {
                        const tenantAdminUrl = `${window.location.origin}/admin`
                        window.location.href = `${env('ROOT_URL')}/api/auth/signin?callbackUrl=${encodeURIComponent(tenantAdminUrl)}`
                      }}
                    >
                      log in
                    </button>
                    {' to view this page.'}
                  </>
                )
            }
          </p>
        </div>
      </AdminLayout>
    )
  }
  return <Page />
}
